import { render, staticRenderFns } from "./SecurityForm.vue?vue&type=template&id=e1472864&"
import script from "./SecurityForm.vue?vue&type=script&lang=js&"
export * from "./SecurityForm.vue?vue&type=script&lang=js&"
import style0 from "./SecurityForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports